import type { MarketingConsentExport } from 'src/trpc';
import { formatPhone } from 'src/utils/format-phone';

const CSV_FORMULA_PREFIX = /^[=+\-@]/;

const neutralizeSpreadsheetFormula = (value: string) =>
  CSV_FORMULA_PREFIX.test(value) ? `'${value}` : value;

// Neutralize inside the escaper so every column is covered by construction. Phone numbers are
// formatted as E.164 and always start with '+', one of the characters spreadsheets treat as a
// formula, so per-column neutralization is too easy to miss on this and any future column.
const escapeCsvField = (value: string) =>
  `"${neutralizeSpreadsheetFormula(value).replace(/"/g, '""')}"`;

export const buildMarketingCsv = (records: MarketingConsentExport[]) => {
  const rows = [
    ['Customer Name', 'Phone Number', 'Opt-in Date', 'Status'],
    ...records.map((record) => [
      record.name || '',
      formatPhone(record.phone || ''),
      record.optInTimestamp
        ? new Date(record.optInTimestamp).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })
        : '',
      record.status === 'opted_in' ? 'Opted in' : 'Opted out',
    ]),
  ];

  return rows.map((row) => row.map(escapeCsvField).join(',')).join('\n');
};
